@if (chips?.length) {
    @if (!collapseThreshold || collapseThreshold >= chips.length) {
        <mat-chip-listbox
                [class.cs-no-chip-wrap]="noWrap">
            @for (chip of chips; track chip) {
                <mat-chip
                        class="cs-flat-chip"
                        (click)="toggleChip(chip)"
                        [ngClass]="sizeClass"
                        [removable]="removable"
                        (removed)="remove(chip)"
                        [csTooltip]="tooltipTemplate"
                        [csTooltipDisabled]="chip.tooltipItems.length < 2  && !tooltipEnabled"
                        [csTooltipDelay]="tooltipDelay"
                        [class.clickable]="clickable"
                        [style.maxWidth.px]="maxWidthPx">
                    @if (clickable && chip.selected) {
                        <mat-icon fontSet="cs-icon"
                                  fontIcon="cs-icon-plain-tick"></mat-icon>
                    }
                    @if (chip.key) {
                        <span
                                class="cs-text-overflow-ellipsis"
                                [matTooltip]="chip.key"
                                csTooltipWhenTruncated
                                [style.maxWidth.px]="maxKeyWidth">{{chip.key}}</span>
                    }
                    @if (chip.key && chip.value) {
                        {{chip.separator || ':'}}
                    }
                    @if (chip.value) {
                        <span
                                class="highlight cs-text-overflow-ellipsis"
                                [matTooltip]="chip.value"
                                csTooltipWhenTruncated
                                [class.clickable]="clickable"
                                [style.maxWidth.px]="maxValueWidth"
                                [style.white-space]="whiteSpaceTagGovernance ? 'pre' : null">{{chipValue(chip)}}</span>
                    }
                    @if (removable) {
                        <button matChipRemove>
                            <mat-icon
                                    fontSet="cs-icon"
                                    fontIcon="cs-icon-close-circle"></mat-icon>
                        </button>
                    }
                    <ng-template #tooltipTemplate>
                        <cs-list-tooltip [list]="chip.tooltipItems"></cs-list-tooltip>
                    </ng-template>
                </mat-chip>
            }
        </mat-chip-listbox>
    }
    @if (collapseThreshold && collapseThreshold < chips.length) {
        <cs-color-chip
                [text]="collapsedText"
                [backgroundColor]="collapsedColor"
                [csTooltip]="outerTooltipTemplate"></cs-color-chip>
    }
    <ng-template #outerTooltipTemplate>
        <cs-key-value-list-tooltip [list]="chips"></cs-key-value-list-tooltip>
    </ng-template>
}
